import { useActiveLang } from "../../app/hooks/useActiveLang";
import { useApiInfiniteQuery } from "../../../services/api";

const limit = 20;

export function useGetCertifiedPlaylistsQuery(
  roomId: string | null,
  params: {
    medicalSpecialties?: string;
    tags?: string;
  } = {}
) {
  const { contentLang } = useActiveLang();

  const query = useApiInfiniteQuery("/webapp/public/playlists/kol", {
    query: {
      limit,
      language: contentLang,
      medical_specialties:
        params.medicalSpecialties !== undefined &&
        params.medicalSpecialties !== ""
          ? params.medicalSpecialties.split(",")
          : undefined,
      tags:
        params.tags !== undefined && params.tags !== ""
          ? params.tags.split(",")
          : undefined,
      roomId: roomId ?? undefined,
    },
  });

  const playlists = query.state === "success" ? query.docs : [];
  const playlistIds = playlists.map((playlist) => playlist.id).join(",");

  return {
    playlists,
    playlistIds,
    isLoading: query.state === "pending",
    isFetching: query.isFetching,
    fetchNextPage:
      query.state === "success" ? query.fetchNextPage : () => void 0,
    canFetchNextPage: query.state === "success" && query.canFetchNextPage,
  };
}
